import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, InputAdornment } from '@mui/material';
import { memo, useCallback, useMemo } from 'react';
import { MaterialBoolControl, StrictNumberInput } from 'console/shared/components/fields';
import { Control } from 'console/shared/components/fields/control';
export const ModulationLevel = memo(function ModulationLevel(props) {
    const { value, onChange } = props;
    const boolean_flag = useMemo(() => (value === 0 || value == undefined ? false : true), [value]);
    const onChangeBoolean = useCallback((flag) => {
        if (flag)
            onChange(100);
        else
            onChange(0);
    }, [onChange]);
    const modulation_number_level = useCallback((input_props) => (_jsx(StrictNumberInput, { ...input_props, min: 1, max: 100, step: 1, endAdornment: _jsx(InputAdornment, { position: "end", children: "%" }) })), []);
    return (_jsxs(Box, { display: "flex", alignItems: "end", children: [_jsx(MaterialBoolControl, { value: boolean_flag, onChange: onChangeBoolean, label: boolean_flag ? undefined : 'Максимальный уровень модуляции', help_id: 'max_modulation_level_Heating_Mode' }), boolean_flag && (_jsx(Box, { minWidth: '80%', children: _jsx(Control, { label: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043C\u043E\u0434\u0443\u043B\u044F\u0446\u0438\u0438", field: modulation_number_level, help_id: '', ...props }) }))] }));
});
